import React, { useCallback, useState, useMemo } from "react";
import { useRouteMatch } from "react-router";
import { Link as RouterLink } from "react-router-dom";

import clsx from "clsx";

import { stringHelpers } from "infrastructure/helpers";
import { MenuList, MenuTextButton } from "ui/components";
import { useUserContext, useAppContext } from "ui/hooks";

import { getAuthorizationData } from "./TopNavigationTenantMenu.helpers";
import styles from "./TopNavigationTenantMenu.module.scss";

export const TopNavigationTenantMenu: React.FC = () => {
  const userContext = useUserContext();
  const routeMatch = useRouteMatch();
  const appContext = useAppContext();

  const tenantId = userContext.getTenantId();
  const tenants = useMemo(() => userContext.getTenants().filter(t => !stringHelpers.equal(t.tenantId, tenantId)), [userContext, tenantId]);
  const currentTenant = useMemo(() => userContext.getTenants().find(t => stringHelpers.equal(t.tenantId, tenantId)), [userContext, tenantId]);

  const [isTenantMenuOpened, setIsTenantMenuOpened] = useState(false);

  const onTenantMenuTriggered = useCallback((isOpened: boolean) => {
    setIsTenantMenuOpened(isOpened);
  }, []);

  const onTenantClick = useCallback(
    (e: React.MouseEvent, tenantId: string) => {
      if (routeMatch) {
        const authorizationData = getAuthorizationData(appContext.routes, routeMatch.path);

        if (userContext.isAuthorizedFor(authorizationData, tenantId)) {
          e.preventDefault();
        }
      }
      userContext.setTenantId(tenantId);
    },
    [userContext, appContext, routeMatch]
  );

  return (
    <MenuList
      onTriggered={onTenantMenuTriggered}
      enabled={!!tenants.length}
      anchor={
        <MenuTextButton enabled={!!tenants.length} className={clsx(styles.navBarTenant, isTenantMenuOpened && styles.navBarMenuOpen)}>
          {currentTenant?.name ?? "---"}
        </MenuTextButton>
      }
    >
      {tenants.map(tenant => (
        <MenuList.Item key={tenant.tenantId}>
          <RouterLink to="/" onClick={e => onTenantClick(e, tenant.tenantId)}>
            {tenant.name}
          </RouterLink>
        </MenuList.Item>
      ))}
    </MenuList>
  );
};
